<template>
  <div class="churnTable">
    <table class="uk-table uk-table-striped vertical">
      <thead>
        <tr>
          <th>Month</th>
          <th>Budget</th>
          <th>CPS ($)</th>
          <th>Sign-Ups</th>
          <th>Percentage of Organic Sign-ups (%)</th>
          <th>Sign-Ups Organic</th>
          <th>Sign-Ups Total</th>
          <th>Free trail to subs. rate (%)</th>
          <th>New Subs from Sign-Ups</th>
          <th>Average Monthly Churn Rate (%)</th>
          <th>Monthly Churn (actual)</th>
          <th>Subscribers</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(month, index) in prediction.months"
          v-bind:key="month.nr"
          :class="{
            first: index == 0,
          }"
        >
          <td>{{ month.nr }}</td>
          <td
            :class="{
              first: index == 0,
            }"
          >
            <currency-input
              class="uk-input"
              min="1"
              v-on:change="monthlyUpdated('budget', month.nr, $event)"
              :value="Number.parseFloat(month.budget)"
              :currency="config.currency"
            />
          </td>
          <td
            :class="{
              first: index == 0,
            }"
          >

            <currency-input
              class="uk-input"
              min="1"
              v-on:change="monthlyUpdated('CPS', month.nr, $event)"
              :value="Number.parseFloat(month.CPS)"
              :currency="config.currency"
            />
          </td>
          <td
            :class="{
              first: index == 0,
            }"
          >
            <span>{{ month.signUps | round }}</span>
          </td>
          <td
            :class="{
              first: index == 0,
            }"
          >
            <input
              type="number"
              class="uk-input"
              step="0.01"
              :value="month.signUpsOrganicPercent"
              v-on:change="
                monthlyUpdated(
                  'signUpsOrganicPercent',
                  month.nr,
                  $event.target.value
                )
              "
            />
          </td>
          <td
            :class="{
              first: index == 0,
            }"
          >
            <span>{{ month.signUpsOrganic | round }}</span>
          </td>
          <td
            :class="{
              first: index == 0,
            }"
          >
            <span>{{ month.totalSignups | round }}</span>
          </td>
          <td
            :class="{
              first: index == 0,
            }"
          >
            <input
              type="number"
              class="uk-input"
              step="0.01"
              :value="month.trialConversionPercent"
              v-on:change="
                monthlyUpdated(
                  'trialConversionPercent',
                  month.nr,
                  $event.target.value
                )
              "
            />
          </td>
          <td
            :class="{
              first: index == 0,
            }"
          >
            <span>{{ month.newSubs | round }}</span>
          </td>
          <td
            :class="{
              first: index == 0,
            }"
          >
            <input
              type="number"
              class="uk-input"
              :value="month.churnPercent"
              v-on:change="
                monthlyUpdated('churnPercent', month.nr, $event.target.value)
              "
            />
          </td>
          <td
            :class="{
              first: index == 0,
            }"
          >
            <span>{{ month.churn | round }}</span>
          </td>
          <td>
            <span>{{ month.subscribers | round }}</span>
          </td>
        </tr>
        <tr class="uk-text-bold">
          <td>Grand Total</td>
          <td>{{ prediction.totalsStrings.budget }}</td>
          <td title="Average monthly">{{ prediction.totalsStrings.CPS }}</td>
          <td>{{ prediction.totalsStrings.signUps }}</td>
          <td>{{ prediction.totalsStrings.signUpsOrganicPercent }}</td>
          <td>{{ prediction.totalsStrings.signUpsOrganic }}</td>
          <td>{{ prediction.totalsStrings.totalSignups }}</td>
          <td>{{ prediction.totalsStrings.trialConversionPercent }}</td>
          <td>{{ prediction.totalsStrings.newSubs }}</td>
          <td>{{ prediction.totalsStrings.churnPercent }}</td>
          <td>{{ prediction.totalsStrings.churn }}</td>
          <td>{{ prediction.totalsStrings.subscribers }}</td>
        </tr>
      </tbody>
    </table>

    <br />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ChurnTable",
  props: {
    id: String,
  },
  filters: {
    round(value) {
      return Math.round(value);
    },
  },
  methods: {
    ...mapActions({
      updateConfig: "churn/updateConfig",
    }),
    monthlyUpdated(field, month, value) {
      let data = {
        id: this.id,
        monthly: {},
      };
      data.monthly[field] = [];
      let monthCount = this.prediction.months.length - 1;
      for (let index = 0; index < monthCount; index++) {
        let val = null;
        if (index == month - 1) {
          val = Number.parseFloat(value);
        }
        data.monthly[field].push(val);
      }
      this.updateConfig(data);
    },
  },
  computed: {
    ...mapGetters({
      getPredictionByID: "churn/getPredictionByID",
      getConfigById: "churn/getConfigByID",
    }),
    config() {
      if (this.getConfigById) {
        return this.getConfigById(this.id);
      }
      return {};
    },
    prediction() {
      if (this.getPredictionByID) {
        return this.getPredictionByID(this.id);
      }
      return {};
    },
  },
};
</script>
<style lang="scss" scoped>
/* Everyone Else's Grid */
@supports (display: grid) {
  .vertical {
    width: 100%;
    display: grid;
    grid-template-columns: min-content auto;
    grid-template-rows: auto auto;
    grid-template-areas:
      "caption caption"
      "head body";
  }
  .vertical thead {
    grid-area: head;
  }
  .vertical tbody {
    grid-area: body;
  }
  .vertical caption {
    grid-area: caption;
  }
}

/* Flex - Cross Browser CSS */
.vertical thead {
  display: flex;
  flex-shrink: 0;
  min-width: 300px;
  tr {
    width: 100%;
  }
  th {
    padding: 8px 8px;
    font-size: 90%;
  }
}
.vertical tbody {
  display: flex;
  justify-content: stretch;

  tr {
    min-width: 120px;
    max-width: 150px;
  }
}
.vertical tr {
  display: flex;
  flex-direction: column;
  min-width: min-content;
  flex-grow: 1;
}
.vertical td,
.vertical th {
  display: block;
}
.vertical caption {
  display: block;
}
.uk-table {
  input {
  }
  td {
    padding: 8px 8px;
    font-size: 90%;
  }
  td,
  th {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: left;
    span {
      padding-left: 10px;
    }
    &.first {
      opacity: 0;
    }
  }
  tr.first {
    width: 20px;
    max-width: 50px;
  }
}
</style>
